import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TestBackend() {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  // Change to your actual backend URL if needed
  const BASE_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.bbsfacultyprofile.com"
      : "http://localhost:5000";

  const token = localStorage.getItem("token"); // optional for protected route

  useEffect(() => {
    const fetchTest = async () => {
      try {
        // public route
        const res = await axios.get(`${BASE_URL}/api/test`);
        setResponse(res.data);

        // protected route (uncomment if testing token)
        // const res = await axios.get(`${BASE_URL}/api/test-protected`, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });
        // setResponse(res.data);
      } catch (err) {
        console.error("Error fetching test endpoint:", err.response || err);
        setError(err.response?.statusText || err.message);
      }
    };

    fetchTest();
  }, [BASE_URL, token]);

  return (
    <div style={{ padding: "50px", fontFamily: "Arial" }}>
      <h2>Backend Test Page</h2>
      {response && <pre>Response: {JSON.stringify(response, null, 2)}</pre>}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
      {!response && !error && <p>Loading...</p>}
    </div>
  );
}
